export default angular.module("EventsApp", ["KhBase"]);